import { Link } from "react-router-dom";

const PRIMARY = [
  { label: "What We Solve", to: "/what-we-solve" },
  { label: "Capabilities", to: "/capabilities" },
  { label: "Network", to: "/network" },
  { label: "Projects", to: "/projects" },
];
const RESOURCES = [
  { label: "Heritage", to: "/heritage" },
  { label: "About", to: "/about" },
  { label: "Evidence framework", to: "/evidence" },
  { label: "Search", to: "/search" },
];
const LEGAL = [
  { label: "Privacy", to: "/privacy" },
  { label: "Terms", to: "/terms" },
  { label: "Accessibility", to: "/accessibility" },
  { label: "Cookie Preferences", to: "/cookies" },
];

export function Footer() {
  return (
    <footer className="border-t border-[var(--line)] bg-[var(--navy)] text-[var(--ivory)]" data-nav-dark data-testid="site-footer">
      <div className="container-dbrf grid gap-10 py-16 md:grid-cols-2 lg:grid-cols-4">
        <div className="max-w-xs">
          <span className="font-display text-2xl font-extrabold">DBRF</span>
          <p className="mt-4 text-sm leading-relaxed text-[var(--ivory)]/70">
            Rare expertise, assembled around difficult problems. A scientific and engineering operating platform for the AI era.
          </p>
        </div>
        <div>
          <p className="eyebrow mb-4 !text-[var(--cyan)]">Primary</p>
          <ul className="space-y-2 text-sm">
            {PRIMARY.map((l) => (
              <li key={l.to}><Link to={l.to} className="text-[var(--ivory)]/80 hover:text-white">{l.label}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <p className="eyebrow mb-4 !text-[var(--cyan)]">Resources</p>
          <ul className="space-y-2 text-sm">
            {RESOURCES.map((l) => (
              <li key={l.to}><Link to={l.to} className="text-[var(--ivory)]/80 hover:text-white">{l.label}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <p className="eyebrow mb-4 !text-[var(--cyan)]">Contact</p>
          <ul className="space-y-2 text-sm text-[var(--ivory)]/80">
            <li>
              <Link to="/bring-a-challenge" data-testid="footer-contact-entity" className="text-[var(--ivory)]/80 hover:text-white">
                Digital Brain Research Foundation LLP
              </Link>
            </li>
            <li>
              <Link to="/about#legal-identity" data-testid="footer-registered-office" className="text-[var(--ivory)]/70 hover:text-white">
                Registered office
              </Link>
            </li>
            <li className="text-[var(--ivory)]/70">
              General enquiries via the{" "}
              <Link to="/bring-a-challenge" data-testid="footer-challenge-link" className="underline decoration-white/30 underline-offset-2 hover:text-white hover:decoration-white">challenge</Link>
              {" "}and{" "}
              <Link to="/join-the-network" data-testid="footer-network-link" className="underline decoration-white/30 underline-offset-2 hover:text-white hover:decoration-white">network</Link>
              {" "}forms
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-dbrf flex flex-col gap-4 py-6 text-xs text-[var(--ivory)]/60 md:flex-row md:items-center md:justify-between">
          <div className="flex flex-wrap gap-4">
            {LEGAL.map((l) => (
              <Link key={l.to} to={l.to} className="hover:text-white">{l.label}</Link>
            ))}
          </div>
          <p>© {new Date().getFullYear()} Digital Brain Research Foundation LLP</p>
        </div>
      </div>
    </footer>
  );
}
